import Icon from '../components/Icon.vue'

Icon.register({
  slash: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M594.5 508.6l-588.4-454.7c-7-5.4-8.2-15.5-2.8-22.5l19.6-25.3c5.4-7 15.5-8.2 22.5-2.8l588.4 454.7c7 5.4 8.2 15.5 2.8 22.5l-19.6 25.3c-5.4 7-15.5 8.2-22.5 2.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/slash.js
// module id = 1900
// module chunks = 0